import { render } from "./my-team-table.vue?vue&type=template&id=1ed0e9b6&scoped=true&ts=true"
import script from "./my-team-table.vue?vue&type=script&lang=ts"
export * from "./my-team-table.vue?vue&type=script&lang=ts"

import "./my-team-table.vue?vue&type=style&index=0&id=1ed0e9b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed0e9b6"]])

export default __exports__